import { Button, ButtonProps } from "@chakra-ui/react";
import { Suspense, useContext } from "react";
import { PlaceSearchContext } from "../search/contexts/place-search";

export type ButtonOpenSearch_T = ButtonProps & {};

export const ButtonOpenSearch = (props: ButtonOpenSearch_T) => {
  const search = useContext(PlaceSearchContext);
  const { children, ...buttonProps } = props;

  return (
    <Suspense
      fallback={
        <Button isLoading {...buttonProps}>
          {children}
        </Button>
      }
    >
      {search ? (
        <Button
          onClick={search?.modal?.onOpen}
          bgColor={buttonProps.bgColor}
          color={buttonProps.color}
          colorScheme={buttonProps.colorScheme}
          borderRadius={buttonProps.borderRadius}
          variant={buttonProps.variant}
          width={buttonProps.width}
        >
          {children}
        </Button>
      ) : (
        <></>
      )}
    </Suspense>
  );
};
